// extracted by mini-css-extract-plugin
export default {"chatBottom":"styles_chatBottom__2DYDt","chatLink":"styles_chatLink__Mc-+U"};